import { CloseIcon } from '@contra/icons/icons';
import { css, styled } from 'styled-components';

const StyledClearButton = styled.button`
  ${({ theme }) => css`
    padding: 4px;
    border-radius: 4px;
    line-height: 1;
    color: ${theme.colorsV2.gray60};

    &:hover,
    &:focus {
      background-color: ${theme.colorsV2.gray20};
    }

    & > svg {
      display: inline-block;
    }
  `}
`;

export const TextFieldClearButton = ({
  onClick,
}: {
  readonly onClick: () => void;
}) => {
  return (
    <StyledClearButton
      aria-label="Clear input"
      onClick={onClick}
      type="button"
    >
      <CloseIcon
        focusable={false}
        size={24}
      />
    </StyledClearButton>
  );
};
